import { IDiskUsage, IStorageInfo } from '@api/systems/api.types'


const GIBIBYTE = 1024 ** 3

export const SYSTEM_STORAGE_MIN_FREE_BYTES = 5 * GIBIBYTE
export const DATA_STORAGE_MIN_FREE_BYTES = 5 * GIBIBYTE

export type TStorageWarningID = 'crm-data' | 'crm-system' | 'yaskill-data' | 'yaskill-system'

export interface IStorageWarning {
    id: TStorageWarningID
    serverName: 'CRM' | 'YASKILL'
    storageName: 'Хранилище' | 'Системный диск'
    storage: IDiskUsage
    minimumFreeBytes: number
}

type StorageCandidate = Omit<IStorageWarning, 'storage'> & {
    storage: IDiskUsage | null
}

export const getStorageWarnings = (storageInfo: IStorageInfo): IStorageWarning[] => {
    const candidates: StorageCandidate[] = [
        {
            id: 'crm-data',
            serverName: 'CRM',
            storageName: 'Хранилище',
            storage: storageInfo.dataStorage,
            minimumFreeBytes: DATA_STORAGE_MIN_FREE_BYTES,
        },
        {
            id: 'crm-system',
            serverName: 'CRM',
            storageName: 'Системный диск',
            storage: storageInfo.systemStorage,
            minimumFreeBytes: SYSTEM_STORAGE_MIN_FREE_BYTES,
        },
        {
            id: 'yaskill-data',
            serverName: 'YASKILL',
            storageName: 'Хранилище',
            storage: storageInfo.yaskill?.dataStorage || null,
            minimumFreeBytes: DATA_STORAGE_MIN_FREE_BYTES,
        },
        {
            id: 'yaskill-system',
            serverName: 'YASKILL',
            storageName: 'Системный диск',
            storage: storageInfo.yaskill?.systemStorage || null,
            minimumFreeBytes: SYSTEM_STORAGE_MIN_FREE_BYTES,
        },
    ]

    return candidates.filter((candidate): candidate is IStorageWarning => (
        candidate.storage !== null && candidate.storage.freeBytes < candidate.minimumFreeBytes
    ))
}